import { render, staticRenderFns } from "./ReportObjectAvatar.vue?vue&type=template&id=8890b460&"
import script from "./ReportObjectAvatar.vue?vue&type=script&lang=js&"
export * from "./ReportObjectAvatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QExpansionItem,QItemSection,QIcon,QItem,QBtn} from 'quasar'
component.options.components = Object.assign({QExpansionItem,QItemSection,QIcon,QItem,QBtn}, component.options.components || {})
